import React, { useEffect, useState } from 'react';
import { Alert } from '../components/Alert';
import { getUrlParameter } from '../utilities/getUrlParameter';
import { RegistrationForm } from './RegistrationForm';
import { RegistrationSubmitted } from './RegistrationSubmitted';
import { onLoad } from '../../script';

const appStyle = 'app-wrapper';
const appSubmittedStyle = 'app-wrapper app-wrapper--submitted';

export const App = () => {
  const [registrationError, setRegistrationError] = useState(false);
  const [dataSubmitted, setDataSubmitted] = useState(false);
  const [sendingData, setSendingData] = useState(false);
  const [hiddenKeyError, setHiddenKeyError] = useState(false);
  const [submissionData, setSubmissionData] = useState(null);

  const appClassName = dataSubmitted ? appSubmittedStyle : appStyle;

  const regToken = getUrlParameter('x-amzn-marketplace-token');

  const onSubmit = (data) => {
    if (regToken) {
      setSubmissionData(data);
    } else {
      setHiddenKeyError(true);
    }
  };

  useEffect(() => {
    if (dataSubmitted) {
      setSendingData(false);
    }
  }, [dataSubmitted]);

  useEffect(() => {
    onLoad();
  }, []);

  const onEditClick = () => {
    setDataSubmitted(false);
  };

  const clearErrors = () => {
    setHiddenKeyError(false);
    setRegistrationError(false);
  };

  return (
    <div className="container">
      <Alert
        hiddenKeyError={hiddenKeyError}
        registrationError={registrationError}
        clearErrors={clearErrors}
      />
      <div className={appClassName}>
        {dataSubmitted && submissionData && !sendingData ? (
          <RegistrationSubmitted
            contactEmail={submissionData.contactEmail}
            adminEmail={submissionData.projectAdminEmail}
            onEditClick={onEditClick}
          />
        ) : (
          <RegistrationForm
            onSubmit={onSubmit}
            sendingData={sendingData}
            submissionData={submissionData}
            setSendingData={setSendingData}
            setDataSubmitted={setDataSubmitted}
            setRegistrationError={setRegistrationError}
          />
        )}
      </div>
    </div>
  );
};
